"use client";

import liveIcon from "@/assets/images/truc-tiep.gif";

export default function DreamnMatchTeam({ homeName, awayName, homeLogo, awayLogo, score, isLive }) {
  const scoreParts = (score || "").split("-");
  const homeScoreVal = scoreParts.length === 2 ? parseInt(scoreParts[0].trim(), 10) : 0;
  const awayScoreVal = scoreParts.length === 2 ? parseInt(scoreParts[1].trim(), 10) : 0;

  return (
    <div className="flex flex-row items-center w-full">
      <div className="team-icon w-10 md:w-20 shrink-0 flex items-center justify-start pl-1">
        {isLive && (
          <img
            src={liveIcon.src || liveIcon}
            alt="Live"
            className="w-[30px] h-[15px] md:w-10 md:h-5 object-contain"
          />
        )}
      </div>

      <div className="team-data flex-1 flex flex-row justify-center items-center gap-1 md:gap-4 ml-1">
        <div className="team-home left flex flex-row justify-end items-center flex-1 bg-transparent gap-1.5 md:gap-2">
          <span
            className="text-xs md:text-sm text-[var(--theme-text)] text-center break-words md:text-right md:truncate max-w-[80px] sm:max-w-[120px] md:max-w-none font-bold"
          >
            {homeName}
          </span>
          {homeLogo && (
            <img src={homeLogo} alt="" className="w-4 h-4 md:w-5 md:h-5 object-contain" onError={(e) => e.target.style.display = 'none'} />
          )}
        </div>

        <div
          className={`team-score middle shrink-0 text-xs md:text-base font-bold min-w-[60px] md:min-w-20 text-center ${isLive
            ? "text-[var(--theme-primary)]"
            : "text-[var(--theme-text)]"
            }`}
        >
          {score}
        </div>

        <div className="team-away right flex flex-row justify-start items-center flex-1 bg-transparent gap-1.5 md:gap-2">
          {awayLogo && (
            <img src={awayLogo} alt="" className="w-4 h-4 md:w-5 md:h-5 object-contain" onError={(e) => e.target.style.display = 'none'} />
          )}
          <span
            className="text-xs md:text-sm text-[var(--theme-text)] md:text-left text-center break-words md:truncate max-w-[80px] sm:max-w-[120px] md:max-w-none font-bold"
          >
            {awayName}
          </span>
        </div>
      </div>

      <div className="team-btn w-10 md:w-20 shrink-0" />
    </div>
  );
}
